/**
 * useConstanciaUrl — resuelve el presigned URL del PDF de la Constancia
 * Cesion Parcial dado el S3 key del row del recon (ccConstanciaS3Key).
 *
 * Lazy: solo dispara la peticion al llamar fetchUrl(). El URL es de corta
 * duracion (~15 min); si el modal queda abierto mucho tiempo, refrescar.
 *
 * Backend: GET /credit/backoffice/contracts/pdf-by-key?key=<urlencoded>
 * El endpoint valida el patron del key contra una whitelist (solo
 * CREDIT_CONSTANCIA_CESION_PARCIAL bajo bucket de contratos).
 */

import { useMutation } from '@tanstack/react-query';
import {
  getConstanciaPdfUrlByKey,
  type ConstanciaPdfUrlResponse,
} from '@/services/ops.service';

export function useConstanciaUrl(key: string | null) {
  const mutation = useMutation<ConstanciaPdfUrlResponse, Error, void>({
    mutationFn: async () => {
      if (!key) throw new Error('S3 key requerido');
      const res = await getConstanciaPdfUrlByKey(key);
      return res.data;
    },
  });

  return {
    fetchUrl: () => mutation.mutate(),
    reset: () => mutation.reset(),
    url: mutation.data?.url ?? null,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
}
